import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/introBreakdownSagas";
import { useDispatch, useSelector } from "react-redux";
import PricingOptions from "./smartComponents/pricingOptions";
import CustomDateRanges from "./smartComponents/customDateRanges";
import DatePicker from "./smartComponents/datePicker";
import NumberDisplay from "../../../components/moneyDisplay/moneyDisplay";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import PieChart from "../../../components/charts/pieChart/pieChart";
import IntroBreakdownTable from "./smartComponents/introBreakdownTable";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
const IntroBreakdownModule = (props) => {
  const {
    isUpdating,
    initialRequest,
    filtersDirty,
    isLoading,
    selectedRequestDates: { startDate, endDate },
    dataPoints,
    introsSoldPieChart,
    visitsPieChart,
    tableData
  } = useSelector((state) => state.introBreakdown);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  const dispatch = useDispatch();

  const updateData = () => {
    if (filtersDirty) {
      dispatch(actionCreators.updateData());
    }
  };
  const resetData = () => {
    dispatch(actionCreators.resetData());
  };

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = () => {
    return (
      <div id="intro-breakdown">
        <div className="edit-selections-bar">
          <div className="select-box">
            <p className="offers-title">Sales Packages</p>
            <PricingOptions />
          </div>

          <div className="select-box">
            <p className="offers-title">Date Range</p>
            <CustomDateRanges />
          </div>

          <div className="date-select-box multi">
            <p className="offers-title">Date</p>
            <DatePicker />
          </div>

          {filtersDirty &&
          !isLoading &&
          startDate !== "Invalid Date" &&
          endDate !== "Invalid Date" ? (
            <button className="submit" onClick={() => updateData()}>
              Update
            </button>
          ) : null}

          {filtersDirty && !isLoading ? (
            <button className="submit reset" onClick={() => resetData()}>
              Reset
            </button>
          ) : null}
        </div>

        {!isUpdating ? (
          <>
            <div className="data-points">
              {dataPoints &&
                dataPoints.map((dataPoint, ind) => {
                  return (
                    <div key={ind} className="data-points__elem">
                      <SectionContainer title={dataPoint.label}>
                        <NumberDisplay
                          value={dataPoint.value}
                          url={dataPoint.link ? dataPoint.link : ""}
                          disableAnimation={isUserQa}
                          decimal={dataPoint.decimal}
                        />
                      </SectionContainer>
                    </div>
                  );
                })}
            </div>
            {introsSoldPieChart.length !== 0 && visitsPieChart.length !== 0 ? (
              <div className="pie-chart">
                <div className="pie-chart__el">
                  <PieChart
                    data={introsSoldPieChart}
                    width={675}
                    height={300}
                    responsive={false}
                    maxSlices={6}
                    showLegend
                    legendPosition="right"
                    isLegendTooltip
                    showPercent
                  />
                </div>
                <div className="pie-chart__el">
                  <PieChart
                    data={visitsPieChart}
                    width={675}
                    height={300}
                    maxSlices={6}
                    addOtherLabel={false}
                    isSortable={false}
                    customTooltip
                    showLegend
                    legendPosition="right"
                    showPercent
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            <IntroBreakdownTable table={tableData} />
          </>
        ) : (
          <LoadingAnimation text="Updating data..." />
        )}
      </div>
    );
  };
  return (
    <SectionToggle
      isLoading={isLoading}
      title={props.chartName}
      content={content()}
      learnMore={
        <KBLearnMore
          title={props.chartName}
          description="This report shows how long it takes intro buyers to convert into paying members and compares conversion performance across intro offer types. These insights help you understand which introductory paths convert best and where your sales process may need refinement."
          kbUrl={ILEARN_URLS.retention.introBreakdown}
        />
      }
    />
  );
};


IntroBreakdownModule.propTypes = { params: PropTypes.object };

export default React.memo(IntroBreakdownModule);
